import DropdownItem from '../DropdownItem'

const GroupedItemList = ({ groupName, items, onClick: closeDropdown }) =>
  <div class={'control-dropdown__list--grouped'}>
    <div class={'control-dropdown__list--group-name'}>{groupName}</div>
    {items.map(item =>
      <DropdownItem
        title={item.title}
        onClick={(e) => { item.onClick(e); closeDropdown() }}
        value={item.value}
      />
    )}
  </div>

export default GroupedItemList
